var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H20M4 8H28M25.3333 8L24.3983 22.0257C24.258 24.13 24.1879 25.1822 23.7334 25.98C23.3332 26.6824 22.7297 27.247 22.0022 27.5996C21.176 28 20.1215 28 18.0125 28H13.9875C11.8785 28 10.824 28 9.99778 27.5996C9.27034 27.247 8.66678 26.6824 8.26664 25.98C7.81215 25.1822 7.742 24.13 7.60171 22.0257L6.66667 8",
    stroke: "#F04242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ed4780cb4d87d564676e954435f5e794.svg";
export { ForwardRef as ReactComponent };